export class MenuItems{
    
    aliasName: string;

    customMenuItem: boolean;

    isCustomMenuItem: boolean;

    position: number;

    realName: string;
}


// WEBPACK FOOTER //
// /app/src/app/core/models/menu-items.ts